import { memo } from 'react';

import AkPage from '@atlaskit/page';
import Spinner from '@atlaskit/spinner';

import { Content } from 'src/app/page.styled';

import * as styles from './loading.style';

type Props = {
  interactionName?: string;
};

export const LoadingPage = memo(
  ({ interactionName = 'loading-page' }: Props) => {
    return (
      <AkPage>
        <Content isBannerOpen={false} consentBannerHeight={0}>
          <styles.Loading>
            <Spinner
              testId="page-loading-spinner"
              delay={0}
              size="large"
              interactionName={interactionName}
            />
          </styles.Loading>
        </Content>
      </AkPage>
    );
  }
);
